import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2016-12-01",
    disableHostPrefix: false,
    regionInfoProvider: defaultRegionInfoProvider,
    signingName: "mobiletargeting",
};
//# sourceMappingURL=runtimeConfig.shared.js.map